import type { FC } from 'react';

import type { IconProps } from './types';

const Drag: FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M127.999 128c0-70.692 57.308-128 128-128h.407c70.692 0 127.997 57.308 127.997 128s-57.305 128-127.997 128h-.407c-70.692 0-128-57.308-128-128m511.599 0c0-70.692 57.309-128 127.997-128H768c70.695 0 128.002 57.308 128.002 128S838.697 256 768 256h-.405c-70.686 0-127.997-57.308-127.997-128M127.999 512.002c0-70.694 57.308-128 128-128h.407c70.692 0 127.997 57.306 127.997 128s-57.305 128-127.997 128h-.407c-70.692 0-128-57.306-128-128m511.599 0c0-70.694 57.309-128 127.997-128H768c70.695 0 128.002 57.306 128.002 128s-57.305 128-128.002 128h-.405c-70.686 0-127.997-57.306-127.997-128M127.999 896.007c0-70.695 57.308-128.002 128-128.002h.407c70.692 0 127.997 57.305 127.997 128.002 0 70.686-57.305 127.993-127.997 127.993h-.407c-70.692 0-128-57.305-128-127.993m511.599 0c0-70.695 57.309-128.002 127.997-128.002H768c70.695 0 128.002 57.305 128.002 128.002C896.002 966.693 838.697 1024 768 1024h-.405c-70.686 0-127.997-57.305-127.997-127.993"
      fill={color}
    />
  </svg>
);

export default Drag;
